export const lazyRoute = <T = any>(
    importFn: () => Promise<T>,
    componentName: keyof T,
    props: any,
) => async () => {
    const module = await importFn();

    const p = props ;

    if (module[componentName] === undefined)
    {
        module['default'].props = p ;

        return {Component: module['default'] }
    }
    else
    {
        module[componentName]['props'] = props ;
        return {Component: module[componentName], props: p};
    }
};
